<template>
    <div>
        <div class="card">
            <div class="card-header text-black p-2">Quotations</div>
            <div class="card-body p-2">
                <div class="overflow-auto" style="max-height: 300px;">
                    <table class="table hm-fs-12 align-middle table-hover table-sm mb-0">
                        <thead>
                            <tr class="sticky-top">
                                <th class="bg-theme">Details</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-if="Object.keys(quotations).length > 0"
                                v-for="(quotation, index) in quotations"
                            >
                                <td @click="$goToPage(`/admin/quotations/${quotation.id}/edit`)" class="cursor-pointer">
                                    <div class="d-flex justify-content-between">
                                        <span class="text-capitalize">{{ quotation?.name }}</span>
                                        <span class="text-uppercase">{{userCurrency}}{{ quotation?.sub_total_amount }}</span>
                                    </div>
                                    <div class="d-flex justify-content-between">
                                        <span class="text-capitalize">{{ $dateTimeFormat(quotation?.created_at, 'DD MMM, YYYY') }}</span>
                                        <span class="text-uppercase">{{ quotation?.postal_code }}</span>
                                    </div>
                                </td>

                            </tr>
                            <tr v-else-if="isLoadingQuotations">
                                <td class="text-center">Loading...</td>
                            </tr>
                            <tr v-else>
                                <td class="text-center">No quotations found</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'QuotationSummary',
    data() {
        return {
            userCurrency: '£',
            quotations: [],
            isLoadingQuotations: true
        }
    },
    mounted() {
        this.getStats();
    },
    methods: {
        getStats() {
            let self = this;
            axios.post('/admin/dashboard/stats?action=quotations', {action: 'quotations'})
                .then(response => {
                    // Get order summary
                    self.quotations = response.data;
                    self.isLoadingQuotations = false;
                });
        },
    }
};
</script>
